import { render } from "./packadd.vue?vue&type=template&id=161aa8ba&scoped=true"
import script from "./packadd.vue?vue&type=script&lang=js"
export * from "./packadd.vue?vue&type=script&lang=js"

import "./packadd.vue?vue&type=style&index=0&id=161aa8ba&scoped=true&lang=css"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-161aa8ba"]])

export default __exports__